import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate } from "react-router-dom";
import "swiper/swiper.min.css";
import img from "../Snacks-Banner.jpg";
import giftVoucherImg from "../Giftvoucher.png";
import { useState, useRef } from "react";
import { useEffect } from "react";
import {
  getBanner,
  getCategory,
  getCategorys,
  getDeals,
} from "../Services/Service";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css"; // Import OwlCarousel CSS
import "owl.carousel/dist/assets/owl.theme.default.css"; // Import OwlCarousel default theme CSS
import jio from "./jio.png";
import { Pane, Text, Pulsar } from "evergreen-ui";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Spinner } from "evergreen-ui";
import { Trophy, Flame } from "lucide-react";
function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const DotStyles = () => (
  <style>
    {`
            /* Target the main dots container */
            .owl-theme .owl-dots {
                 margin-top: 0px; /* Reduced space above dots */
                text-align: center;
            }
            /* Target the individual dots (buttons) */
            .owl-theme .owl-dots .owl-dot span {
                width: 7px;     /* Reduced width */
                height: 7px;    /* Reduced height */
                margin: 0 4px;  /* Reduced margin between dots */
                background: rgba(255, 255, 255, 0.5); /* Lighter inactive dot */
                display: block;
                -webkit-backface-visibility: visible;
                transition: opacity 0.2s ease;
                border-radius: 30px;
            }
            /* Style for the active dot */
            .owl-theme .owl-dots .owl-dot.active span, 
            .owl-theme .owl-dots .owl-dot:hover span {
                background: #FFFFFF; /* Bright white for active dot */
            }
        `}
  </style>
);
const LazyImage = ({ src, skeleton, isDiscount }) => {
  const rootRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const loading = "https://media.giphy.com/media/3o6UBpHgaXFDNAuttm/giphy.gif";

  useEffect(() => {
    const defaultIntersectionOptions = {
      threshold: 0,
      rootMargin: "0px",
    };

    const checkIntersections = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, 200);
        }
      });
    };

    if (!isVisible) {
      const newIO = new IntersectionObserver(
        checkIntersections,
        defaultIntersectionOptions
      );
      newIO.observe(rootRef.current);
      return () => newIO.disconnect();
    }
  }, [isVisible]);

  return (
    <>
      {isVisible ? (
        src
      ) : (
        <div
          ref={rootRef}
          style={
            isDiscount
              ? {
                  margin: "5px 5px 5px 5px",
                  width: "auto",
                  height: "auto",
                  padding: "0px",
                }
              : {}
          }
        >
          {skeleton}
        </div>
      )}
    </>
  );
};
const ProductSlider = (props) => {
  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      pagination={{ clickable: true }}
      // onSlideChange={(e) => console.log("slide change")}
      // onSwiper={(swiper) => console.log(swiper)}
    >
      {props?.imagesArr && props?.imagesArr !== undefined
        ? props?.imagesArr.map((item, i) => {
            return (
              <SwiperSlide key={item.image}>
                <a href={`${item.image}`}>
                  <img
                    src={item.image}
                    className="img-fluid imgbanner"
                    alt={item.description}
                    // loading="lazy"
                    // style={{ display: loading ? 'none' : undefined }}
                  />
                </a>
              </SwiperSlide>
            );
          })
        : "No IndexSlides"}
    </Swiper>
  );
};

const IndexSlider = ({ banner }) => {
  const [indexImg, setIndexImg] = useState(banner || []); // Initialize with empty array or banner prop
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (banner && banner.length > 0) {
      setIndexImg(banner);
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [banner]);

  return (
    <>
      {loading ? (
        <div className="container d-flex justify-content-center align-items-center">
          <Spinner /> {/* Show a spinner while loading */}
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12 px-2 py-2">
              <Swiper
                loop={true}
                spaceBetween={10}
                slidesPerView={1.1}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                centeredSlides={true}
              >
                {indexImg.length > 0 ? (
                  indexImg.map((item, i) => (
                    <SwiperSlide
                      key={i}
                      style={{ borderRadius: "5px" }}
                      className="index-swiper-slide"
                    >
                      <LazyImage
                        src={
                          <Link
                            to={`/products/${item.vendorId}`}
                            state={`${"vendorId"}`}
                          >
                            <img
                              src={item.productImage}
                              className="img-fluid banner-img"
                              alt={item.categoryTitle}
                              style={{
                                width: "85vw",
                                height: "26vh",
                                borderRadius: "15px",
                              }}
                              loading="lazy" // Keep lazy loading
                            />
                          </Link>
                        }
                        key={item.id}
                        skeleton={
                          <span
                            className="skeleton-box"
                            style={{
                              width: "85vw",
                              height: "auto",
                              borderRadius: "15px",
                            }}
                          />
                        }
                      />
                    </SwiperSlide>
                  ))
                ) : (
                  <p>No slides available</p>
                )}
              </Swiper>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const BannerSlider = ({ banner }) => {
  const [indexImg, setIndexImg] = useState(banner || []);
  const [loading, setLoading] = useState(!banner || banner.length === 0);

  // Optimized image loading and caching check
  useEffect(() => {
    if (banner && banner.length > 0) {
      setIndexImg(banner);

      // Check cache and load images
      const loadBannerImages = () => {
        let loadedCount = 0;
        const totalImages = banner.filter((item) => item.imageUrl).length;

        if (totalImages === 0) {
          setLoading(false);
          return;
        }

        banner.forEach((item, index) => {
          if (item.imageUrl) {
            const img = new Image();

            img.onload = () => {
              loadedCount++;
              // Hide loading when first image is ready (for better UX)
              if (loadedCount === 1) {
                setLoading(false);
              }
            };

            img.onerror = () => {
              loadedCount++;
              // Still show banner even if image fails
              if (loadedCount === 1) {
                setLoading(false);
              }
            };

            // Check if already cached (browser cache)
            if (img.complete) {
              loadedCount++;
              if (loadedCount === 1) {
                setLoading(false);
              }
            }

            // Start loading
            img.src = item.imageUrl;
          }
        });

        // Fallback: Show banner after 300ms max (faster than before)
        const timeout = setTimeout(() => {
          setLoading(false);
        }, 300);

        // Clear timeout if all images loaded quickly
        if (loadedCount === totalImages) {
          clearTimeout(timeout);
          setLoading(false);
        }
      };

      loadBannerImages();
    } else {
      setLoading(false);
    }
  }, [banner]);

  return (
    <>
      {loading ? (
        <div className="container d-flex justify-content-center align-items-center">
          <Spinner /> {/* Show a spinner while loading */}
        </div>
      ) : (
        <div className="container-fluid px-0">
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true, dynamicBullets: true }}
            loop={indexImg.length > 1}
            className="modern-banner-swiper"
            centeredSlides={true}
            onSlideChange={() => {}}
            onSwiper={(swiper) => {}}
          >
            {indexImg.length > 0 ? (
              indexImg.map((item, i) => (
                <SwiperSlide key={i}>
                  <div className="banner-slide-container">
                    <Link to={`${item.url}`} className="banner-slide-link">
                      <div className="banner-image-wrapper">
                        <img
                          src={item.imageUrl}
                          alt={item.categoryTitle}
                          className="img-fluid banner-img modern-banner-img"
                          loading="eager"
                          decoding="async"
                        />
                        <div className="banner-overlay"></div>
                      </div>
                    </Link>
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <SwiperSlide>
                <p
                  style={{
                    color: "#fff",
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  No slides available
                </p>
              </SwiperSlide>
            )}
          </Swiper>
        </div>
      )}
    </>
  );
};

const CategorySlider = ({ catImg }) => {
  const loading = !catImg || catImg.length === 0;

  return (
    <div className="container">
      <section className="category-slider-section">
        <div className="d-flex justify-content-center align-items-center">
          <SectionHeader
            title="Explore Categories"
            icon={<Flame color="#e0ca00" />}
          />
        </div>
        <div className="d-flex justify-content-center">
          {loading ? (
            <div className="d-flex justify-content-center py-1">
              <Spinner />
            </div>
          ) : (
            <div className="category-slider-container">
              {catImg.map((item, index) => (
                <Link
                  key={item.categoryId || index}
                  to={
                    item.categoryTitle === "Mobile Recharge"
                      ? `/mobile`
                      : `/products/${item.categoryId}`
                  }
                  className="category-item-link"
                >
                  <div className="category-item-wrapper">
                    <div className="category-icon-container">
                      <div className="category-icon-ring"></div>
                      <div className="category-icon-circle">
                        <img
                          src={item.categoryImage}
                          alt={item.categoryTitle}
                          className="category-icon-image"
                        />
                      </div>
                    </div>
                    <span className="category-item-title">
                      {item.categoryTitle}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* NOTE: To fully achieve the effect, you would need the following custom CSS
        (or implement the styles using state/props if you must stick to inline styles): 
      */}
      {/* <style>
          .enhanced-gamified-link:hover .category-game-button {
            transform: scale(1.05) translateY(-2px); // Subtle lift
            box-shadow: 
              0 0 20px rgba(255, 230, 0, 1), // Stronger glow on hover
              0 8px 20px rgba(0, 0, 0, 0.6); // Stronger outer shadow
          }
          .enhanced-gamified-link:active .category-game-button {
            transform: scale(0.95); // "Click" press effect
            box-shadow: 
              0 0 5px rgba(255, 230, 0, 0.5), 
              inset 0 0 10px rgba(0, 0, 0, 0.5); // Inset shadow for press
          }
        </style> 
      */}
    </div>
  );
};

const OtherProductSlider = ({ imga, ra, nge, List, name }) => {
  const [bannerImg, setBannerImg] = useState();
  const [cateogoryImg, setCategoryImg] = useState([]);
  useEffect(() => {
    setCategoryImg(List?.slice(ra, nge));
    setBannerImg(imga);
  }, [List]);
  return (
    <>
      <div className="container bg-common">
        <h3 className="text-start mb-2 mt-2"> {"Discounts"} </h3>
        <div className="row">
          {cateogoryImg && cateogoryImg !== undefined
            ? cateogoryImg.map((item) => (
                <div className="col-6 col-md-3 mb-3" key={item.productId}>
                  {/* Updated Link component with the category prop in the URL */}
                  <Link
                    to={
                      name === "Mobile"
                        ? `/mobile`
                        : `/productdetails/${item.productId}`
                    }
                    state={{
                      data: item.productTitle,
                      operatorId: item.operatorId,
                    }}
                  >
                    <img
                      src={item.productImage}
                      className="img-fluid mt-3 rounded"
                      alt={item.productTitle}
                      onClick={() => {
                        sessionStorage.setItem(
                          "homescroll",
                          JSON.stringify({
                            homeScroll:
                              document.querySelector(".content-app").scrollTop,
                          })
                        );
                      }}
                    />
                  </Link>
                </div>
              ))
            : "No Discounts"}
        </div>
      </div>

      {/* 
<div className="row other-products py-3">
        <h3 className="heading_other">
            {"Discounts"}{" "}
          </h3>
      <div className="col-12 py-3">
        <Swiper
          spaceBetween={10}
          slidesPerView={1.5}
        >
          {cateogoryImg && cateogoryImg !== undefined
            ? cateogoryImg.map((item,i) => {
                return (
                  <SwiperSlide key={item.categoryId+i}>
                    <LazyImage src={<div className="sldCol40">
  <Link to={`/products/${item.categoryId}`}>
    <div className="sldImgBox_rect_1" >
      <img
      onClick={()=>{sessionStorage.setItem("homescroll",JSON.stringify({homeScroll:document.querySelector(".content-app").scrollTop}))}}
        src={item.productImage}
        data-src="https://assets.tatacliq.com/medias/sys_master/images/46450001313822.jpg"
        className="sldImgBoxInner sldImgOpcty"
        alt="Shop Now"
        style={{ width: "50%",borderRadius:"10px"}}
      />
    </div>
    <div className="prodInfo">
      <div className="prodName text-center">
<div className="rowGap10" />
<div className="brndTitle">
  <div className="h3">UP TO {item.off}% OFF</div>
</div>

      </div>
    </div>
  </Link>
</div>} skeleton={<div className="sldCol40">
<span className="skeleton-box" style={{ height: "32vh", width: "59vw",borderRadius:"10px"}} />
</div>}/>
                  </SwiperSlide>
                );
              })
            : "No IndexSlides"}
        </Swiper>
      </div>
    </div> */}
    </>
  );
};

const DealofDaySlider = (props) => {
  const img = props.deals;

  const [indexImg, setIndexImg] = useState(props.deals);
  useEffect(() => {
    setIndexImg(props.deals);
  }, [props.deals]);

  // Style for the main container (REDUCED PADDING/MARGIN)
  const containerBackgroundStyle = {
    // backgroundColor: "rgba(3, 54, 74, 0.71)", // Dark blue background
    padding: "20px", // Minimal vertical padding, moderate horizontal
    borderRadius: "10px",
    // margin: "13px",
    marginTop: "20px", // Reduced top/bottom margin for less screen space
  };

  // --- Card Styling Functions ---

  const getCardStyle = (i) => ({
    // backgroundColor: "#005b7f",
    backgroundColor: "#025a7c", // Slightly translucent white
    borderRadius: "15px",
    padding: "10px", // Reduced card internal padding
    // Margin for the card itself is managed by the OwlCarousel margin and the `item` div
    margin: "0 5px 10px 5px", // Reduced bottom margin (for shadow space)
    boxShadow: "0 8px 15px rgba(0, 0, 0, 0.3)", // Slightly softer shadow
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "left",
    minHeight: "200px", // Reduced minimum height for a more compact card
    textDecoration: "none",
    color: "#333",
  });

  const getImageWrapperStyle = {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    // Adjusted negative margin to keep the image centered and slightly less floating
    marginTop: "-50px",
    marginBottom: "5px", // Reduced space below image box
  };

  const getImageBoxStyle = {
    width: "150px", // Slightly smaller image box
    height: "150px", // Slightly smaller image box
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "3px", // Reduced padding
  };

  // --- Component Render ---

  return (
    <div className="container" style={containerBackgroundStyle}>
      {/* Inject small dot styles */}
      <DotStyles />

      {img && img.length > 0 && <h3 className="text-center mb-4">TOP DEALS</h3>}

      <OwlCarousel
        id="deal"
        className="owl-theme"
        loop={img && img.length > 1}
        margin={10}
        items={1}
        nav={false}
        dots={false}
        autoplay={img && img.length > 1}
        autoplayTimeout={5000}
        responsive={{
          0: {
            items: 1,
          },
          576: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1000: {
            items: 3,
          },
        }}
      >
        {img && img.length > 0 ? (
          img.map((item, i) => {
            const spiceGold =
              item.spicegold || item.productPrice - item.offerPrice;

            return (
              // Reduced paddingTop on the item div
              <div key={i} className="item" style={{ paddingTop: "40px" }}>
                <Link
                  to={`/productdetails/${item.productId}`}
                  className="top-deal-card"
                >
                  {/* Discount Badge */}
                  {item.productPrice > item.offerPrice && (
                    <div className="top-deal-discount-badge">
                      {Math.round(
                        ((item.productPrice - item.offerPrice) /
                          item.productPrice) *
                          100
                      )}
                      % OFF
                    </div>
                  )}

                  {/* 1. Floating Image Section */}
                  <div className="top-deal-image-wrapper">
                    <div className="top-deal-image-box">
                      <img
                        src={item.productImage}
                        alt={item.productTitle}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          objectPosition: "center",
                        }}
                      />
                    </div>
                  </div>

                  {/* 2. Card Body/Content */}
                  <div className="top-deal-content">
                    {/* Product Title */}
                    <h1 className="top-deal-title">
                      {item.productTitle.length > 30
                        ? `${item.productTitle.slice(0, 30)}..`
                        : item.productTitle}
                    </h1>

                    {/* Price Section - More Prominent */}
                    <div className="top-deal-pricing-section">
                      {/* Original Price */}
                      <div className="top-deal-original-price">
                        <span className="price-label">MRP</span>
                        <span className="strikethrough-price">
                          ₹{item.productPrice.toLocaleString("en-IN")}
                        </span>
                      </div>

                      {/* Final Price - Highlighted */}
                      <div className="top-deal-final-price">
                        <span className="you-pay-label">You Pay:</span>
                        <div className="price-amounts">
                          <span className="cash-amount">
                            ₹{item.offerPrice.toLocaleString("en-IN")}
                          </span>
                          {spiceGold > 0 && (
                            <span className="spicegold-badge">
                              <span className="spicegold-plus">+</span>
                              <span className="spicegold-value">
                                {spiceGold}
                              </span>
                              <span className="spicegold-label">Sg</span>
                              <img
                                className="spicegold-icon"
                                src={"/assets/images/spicegold.png"}
                                alt="SpiceGold Coin"
                              />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })
        ) : (
          <div className="top-deals-empty-state">
            <div className="top-deals-empty-box">
              <h3 className="top-deals-empty-title">TOP DEALS</h3>
              <div className="top-deals-empty-underline"></div>
              <p className="top-deals-empty-message">No Deals Available</p>
            </div>
          </div>
        )}
      </OwlCarousel>
    </div>
  );
};

const Mobile = ({ imga, number, name, ra, nge, category, List }) => {
  const [bannerImg, setBannerImg] = useState();
  const [indexImg, setIndexImg] = useState(List);

  useEffect(() => {
    setIndexImg(List?.slice(ra, nge));
    setBannerImg(imga);
  }, [List]);

  return (
    <>
      <div className="mob-recharge">
        <h3 className="text-start mb-2 mt-2">Mobile</h3>
        <div className="row">
          <div className="col-12 mb-3">
            <div>
              <Link to="/mobile">
                <img src={bannerImg} className="rounded mob-banner" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <ul className="d-flex flex-row list-unstyled">
          <li className="me-2" style={{ flex: "0 100%" }}>
            <Link to="/mobile">
              <div className="mob-comp d-flex justify-content-center align-items-center">
                <img src={jio} alt="" />
              </div>
            </Link>
          </li>
          <li className="d-flex flex-column">
            <Link to="/mobile" className="mb-2">
              <div className="mob-comp d-flex justify-content-center align-items-center">
                <img
                  src="https://appcdn.goqii.com/storeimg/61968_1684827763.com"
                  alt=""
                />
              </div>
            </Link>
            <Link to="/mobile">
              <div className="mob-comp d-flex justify-content-center align-items-center">
                <img
                  src="https://appcdn.goqii.com/storeimg/3537_1684827802.png"
                  alt=""
                />
              </div>
            </Link>
          </li>
        </ul>
        <ul className="d-flex list-unstyled">
          <li className="me-2">
            <Link to="/mobile">
              <div className="mob-comp d-flex justify-content-center align-items-center">
                <img
                  src="https://appcdn.goqii.com/storeimg/64887_1684827507.png"
                  alt=""
                />
              </div>
            </Link>
          </li>
          <li>
            <Link to="/mobile">
              <div className="mob-comp d-flex justify-content-center align-items-center">
                <img
                  src="https://appcdn.goqii.com/storeimg/50818_1684827616.png"
                  alt=""
                />
              </div>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

const Discounts = ({ imga, number, name, ra, nge, category, List }) => {
  const [bannerImg, setBannerImg] = useState();
  const [indexImg, setIndexImg] = useState(List);

  useEffect(() => {
    setIndexImg(List?.slice(ra, nge));
    setBannerImg(imga);
  }, [List, ra, nge, imga]);

  return (
    <div className="container px-1 mx-1">
      <div className="category-slider-wrapper">
        {/* Enhanced Cover Banner Section */}
        <div className="category-cover-banner">
          <Link to={`/products/${category}`} className="category-banner-link">
            {bannerImg ? (
              <div className="category-banner-container">
                <img
                  src={bannerImg}
                  className="category-cover-image"
                  alt={name}
                  onClick={() => {
                    sessionStorage.setItem(
                      "homescroll",
                      JSON.stringify({
                        homeScroll:
                          document.querySelector(".content-app")?.scrollTop ||
                          0,
                      })
                    );
                  }}
                />
                <div className="category-banner-overlay">
                  <div className="category-banner-content">
                    <h2 className="category-banner-title">{name}</h2>
                    <div className="category-banner-cta">
                      <span className="category-view-all-btn">View All</span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="category-banner-split-design">
                <div className="category-banner-left-section">
                  <div className="category-banner-left-content">
                    <h2 className="category-banner-category-name">{name}</h2>
                    <p className="category-banner-tagline">
                      GAME IN COMFORT & STYLE!
                    </p>
                    <p className="category-banner-subtitle">
                      Trendy apparels for gamers
                    </p>
                    <span className="category-view-all-btn-primary">
                      VIEW ALL
                    </span>
                  </div>
                </div>
                <div className="category-banner-right-section">
                  <div className="category-banner-pattern"></div>
                </div>
              </div>
            )}
          </Link>
        </div>

        {/* Enhanced Products Section */}
        <div className="category-products-section">
          <OwlCarousel
            className="owl-theme category-products-carousel"
            loop={indexImg && indexImg.length > 4}
            margin={12}
            items={4}
            dots={false}
            nav={false}
            autoplay={true}
            autoplayTimeout={4000}
            autoplayHoverPause={true}
            responsive={{
              0: {
                items: 2,
                nav: false,
                margin: 8,
              },
              576: {
                items: 2,
                margin: 10,
              },
              768: {
                items: 3,
                margin: 12,
              },
              1000: {
                items: 4,
                margin: 12,
              },
            }}
          >
            {indexImg && indexImg !== undefined && indexImg.length > 0 ? (
              indexImg.map((item) => {
                return (
                  <div
                    className="item category-product-item"
                    key={item.productId}
                  >
                    <Link
                      to={
                        name === "Mobile"
                          ? `/mobile`
                          : `/productdetails/${item.productId}`
                      }
                      state={{
                        data: item.productTitle,
                        operatorId: item.operatorId,
                      }}
                      className="category-product-link"
                    >
                      <div className="category-product-card">
                        <div className="category-product-image-wrapper">
                          <img
                            src={item.productImage}
                            className="category-product-image"
                            alt={item.productTitle}
                            onClick={() => {
                              sessionStorage.setItem(
                                "homescroll",
                                JSON.stringify({
                                  homeScroll:
                                    document.querySelector(".content-app")
                                      ?.scrollTop || 0,
                                })
                              );
                            }}
                          />
                        </div>
                        {item.productTitle && (
                          <div className="category-product-info">
                            <p className="category-product-title">
                              {item.productTitle.length > 30
                                ? `${item.productTitle.slice(0, 30)}...`
                                : item.productTitle}
                            </p>
                          </div>
                        )}
                      </div>
                    </Link>
                  </div>
                );
              })
            ) : (
              <div className="category-no-products">No products available</div>
            )}
          </OwlCarousel>
        </div>
      </div>

      {/* <div>
              <div className="autoImageBanner" style={{ height: "22.23vw" ,marginBottom:"10px"}}>
              <h1 className="heading">
            {name}{" "}
     
          </h1>
          <Link to={name==="Mobile"?`/mobile`:`/products/${category}`}>
                  <img
                    onClick={()=>{sessionStorage.setItem("homescroll",JSON.stringify({homeScroll:document.querySelector(".content-app").scrollTop}))}}
                    src={bannerImg}
                    className="imgBlock"
                    alt={`${name} images`}
                    width={720}
                    height={160}
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </Link>
              </div>
            </div>
            <div className="rowGap10" />
            <div className="rowGap10" />

      <div className="row" style={{padding:"15px"}}>
        <div className="col-12 pb-2">
         
        </div>
        {indexImg && indexImg !== undefined
          ? indexImg.map((item) => {
              return (
                <LazyImage src={
                  <div className="" key={item.productId} style={{margin:"5px 5px 5px 5px",width:"auto", height:"auto",padding:"0px",}}>
                  <Link to={name==="Mobile"?`/mobile`:`/productdetails/${item.productId}`} state={{ data: item.productTitle,operatorId:item.operatorId}}>
                    <img
                      style={{ width: "43vw", height: "21vh" ,padding: "5px",
                      background: "white"}}
                      src={item.productImage}
                      className="img-fluid"
                      alt={item.productTitle}
                      onClick={()=>{sessionStorage.setItem("homescroll",JSON.stringify({homeScroll:document.querySelector(".content-app").scrollTop}))}}
                    />
                  </Link>
                </div>} key={item.productId} skeleton={<span className="skeleton-box" style={{ width: "43vw", height: "21vh",borderRadius:"10px" }} />} isDiscount={true}/>
              );
            })
          : "No Discounts"}
      </div> */}
    </div>
  );
};

const filterCategorySlider = (props) => {
  return <></>;
};

const Discountss = ({ imga, number, name, ra, nge, category, List }) => {
  // console.log(number)
  // const [indexImg, setIndexImg] = useState([]);
  const [bannerImg, setBannerImg] = useState();
  // console.log(indexImg)
  const [indexImg, setIndexImg] = useState([{}, {}, {}, {}]);
  // console.log(indexImg)
  useEffect(() => {
    setIndexImg(List?.slice(ra, nge));
    setBannerImg(imga);
  }, [List]);
  // useEffect(() => {
  //   getDeals()
  //     .then((resp) => {
  //       console.log(resp.data)
  //       // if(name ==="3"){
  //         const indexImgList =resp.data.data.category.filter(item=>item.categoryId===category);
  //       //   const indexImgList =resp.data.data.deal.slice(ra, nge);
  //       // return indexImgList;
  //       // }else{
  //         console.log(indexImgList)
  //         const random = randomIntFromInterval(0,5)
  //         console.log(random, random+3)
  //         const x =indexImgList.slice(0,4);
  //         const bannerImgList =resp.data.data.banner.filter(item=>item.productCategory===category);
  //         console.log(bannerImgList)
  //         setBannerImg(bannerImgList[0].productImage)
  //         return x;
  //       // }

  //     })
  //     .then((data) => setIndexImg(data))
  //     .catch((err) => console.log(err.message));
  //   // getBanner()
  //   //   .then((resp) => {
  //   //     const indexImgList = resp.data.products.slice(5, 9);
  //   //     return indexImgList;
  //   //   })
  //   //   .then((data) => setIndexImg(data))
  //   //   .catch((err) => console.log(err.message));
  // }, []);

  return (
    <>
      <div>
        <div
          className="autoImageBanner"
          style={{ height: "22.23vw", marginBottom: "10px" }}
        >
          <h1 className="heading">
            {name}{" "}
            {/* <Link to={name==="Mobile"?`/mobile`:`/products/${category}`}>
              <button
                type="button"
                className="btn btn-link pull-right btn-link-view-all"
              >
                View all
              </button>
            </Link> */}
          </h1>
          <Link to={name === "Mobile" ? `/mobile` : `/products/${category}`}>
            <img
              onClick={() => {
                sessionStorage.setItem(
                  "homescroll",
                  JSON.stringify({
                    homeScroll:
                      document.querySelector(".content-app").scrollTop,
                  })
                );
              }}
              src={bannerImg}
              className="imgBlock"
              alt={`${name} images`}
              width={720}
              height={160}
              style={{
                height: "auto",
                maxWidth: "100%",
                borderRadius: "10px",
              }}
            />
          </Link>
        </div>
      </div>
      <div className="rowGap10" />
      <div className="rowGap10" />

      <div className="row" style={{ padding: "15px" }}>
        <div className="col-12 pb-2">
          {/* <h1 className="heading">
            {name}{" "}
            <Link to={name==="Mobile"?`/mobile`:`/products/${category}`}>
              <button
                type="button"
                className="btn btn-link pull-right btn-link-view-all"
              >
                View all
              </button>
            </Link>
          </h1> */}
        </div>
        {indexImg !== undefined && indexImg.length > 0 ? (
          <>
            <LazyImage
              src={
                <div
                  className=""
                  key={indexImg[0]?.productId}
                  style={{
                    margin: "5px 5px 5px 5px",
                    width: "auto",
                    height: "auto",
                    padding: "0px",
                  }}
                >
                  <Link
                    to={
                      name === "Mobile"
                        ? `/mobile`
                        : `/productdetails/${indexImg[0]?.productId}`
                    }
                    state={{ data: "Reliance JIO", operatorId: "3" }}
                  >
                    <img
                      style={{
                        width: "61vw",
                        height: "27.5vh",
                        padding: "15px",
                        background: "#fff",
                      }}
                      src={
                        "https://appcdn.goqii.com/storeimg/74334_1684827674.png"
                      }
                      className="img-fluid"
                      alt={indexImg[0]?.productTitle}
                      onClick={() => {
                        sessionStorage.setItem(
                          "homescroll",
                          JSON.stringify({
                            homeScroll:
                              document.querySelector(".content-app").scrollTop,
                          })
                        );
                      }}
                    />
                  </Link>
                </div>
              }
              key={indexImg[0]?.productId}
              skeleton={
                <span
                  className="skeleton-box"
                  style={{
                    width: "61vw",
                    height: "27.5vh",
                    borderRadius: "15px",
                  }}
                />
              }
              isDiscount={true}
            />
            <div
              style={{
                display: "flex",
                width: "auto",
                padding: 0,
                flexDirection: "column",
              }}
            >
              <LazyImage
                src={
                  <div
                    className=""
                    key={indexImg[1]?.productId}
                    style={{
                      margin: "5px 5px 5px 5px",
                      width: "auto",
                      height: "auto",
                      padding: "0px",
                    }}
                  >
                    <Link
                      to={
                        name === "Mobile"
                          ? `/mobile`
                          : `/productdetails/${indexImg[1].productId}`
                      }
                      state={{ data: "BSNL", operatorId: "4" }}
                    >
                      <img
                        style={{
                          width: "25vw",
                          height: "13vh",
                          padding: "15px",
                          background: "#fff",
                        }}
                        src={
                          "https://appcdn.goqii.com/storeimg/61968_1684827763.com"
                        }
                        className="img-fluid"
                        alt={indexImg[1]?.productTitle}
                        onClick={() => {
                          sessionStorage.setItem(
                            "homescroll",
                            JSON.stringify({
                              homeScroll:
                                document.querySelector(".content-app")
                                  .scrollTop,
                            })
                          );
                        }}
                      />
                    </Link>
                  </div>
                }
                key={indexImg[1]?.productId}
                skeleton={
                  <span
                    className="skeleton-box"
                    style={{
                      width: "25vw",
                      height: "13vh",
                      borderRadius: "15px",
                    }}
                  />
                }
                isDiscount={true}
              />
              <LazyImage
                src={
                  <div
                    className=""
                    key={indexImg[2]?.productId}
                    style={{
                      margin: "5px 5px 5px 5px",
                      width: "auto",
                      height: "auto",
                      padding: "0px",
                    }}
                  >
                    <Link
                      to={
                        name === "Mobile"
                          ? `/mobile`
                          : `/productdetails/${indexImg[2]?.productId}`
                      }
                      state={{ data: "MTNL", operatorId: "5" }}
                    >
                      <img
                        style={{
                          width: "25vw",
                          height: "13vh",
                          padding: "15px",
                          background: "#fff",
                        }}
                        src={
                          "https://appcdn.goqii.com/storeimg/3537_1684827802.png"
                        }
                        className="img-fluid"
                        alt={indexImg[2]?.productTitle}
                        onClick={() => {
                          sessionStorage.setItem(
                            "homescroll",
                            JSON.stringify({
                              homeScroll:
                                document.querySelector(".content-app")
                                  .scrollTop,
                            })
                          );
                        }}
                      />
                    </Link>
                  </div>
                }
                key={indexImg[2]?.productId}
                skeleton={
                  <span
                    className="skeleton-box"
                    style={{
                      width: "25vw",
                      height: "13vh",
                      borderRadius: "15px",
                    }}
                  />
                }
                isDiscount={true}
              />
            </div>
            <LazyImage
              src={
                <div
                  className=""
                  key={indexImg[3]?.productId}
                  style={{
                    margin: "5px 5px 5px 5px",
                    width: "auto",
                    height: "auto",
                    padding: "0px",
                  }}
                >
                  <Link
                    to={
                      name === "Mobile"
                        ? `/mobile`
                        : `/productdetails/${indexImg[3]?.productId}`
                    }
                    state={{ data: "Airtel", operatorId: "2" }}
                  >
                    <img
                      style={{
                        width: "43vw",
                        height: "21vh",
                        padding: "15px",
                        background: "#fff",
                      }}
                      src={
                        "https://appcdn.goqii.com/storeimg/64887_1684827507.png"
                      }
                      className="img-fluid"
                      alt={indexImg[3]?.productTitle}
                      onClick={() => {
                        sessionStorage.setItem(
                          "homescroll",
                          JSON.stringify({
                            homeScroll:
                              document.querySelector(".content-app").scrollTop,
                          })
                        );
                      }}
                    />
                  </Link>
                </div>
              }
              key={indexImg[3]?.productId}
              skeleton={
                <span
                  className="skeleton-box"
                  style={{
                    width: "43vw",
                    height: "21vh",
                    borderRadius: "15px",
                  }}
                />
              }
              isDiscount={true}
            />
            <LazyImage
              src={
                <div
                  className=""
                  key={indexImg[4]?.productId}
                  style={{
                    margin: "5px 5px 5px 5px",
                    width: "auto",
                    height: "auto",
                    padding: "0px",
                  }}
                >
                  <Link
                    to={
                      name === "Mobile"
                        ? `/mobile`
                        : `/productdetails/${indexImg[4]?.productId}`
                    }
                    state={{ data: "Vodafone Idea", operatorId: "1" }}
                  >
                    <img
                      style={{
                        width: "43vw",
                        height: "21vh",
                        padding: "15px",
                        background: "#fff",
                      }}
                      src={
                        "https://appcdn.goqii.com/storeimg/50818_1684827616.png"
                      }
                      className="img-fluid"
                      alt={indexImg[4]?.productTitle}
                      onClick={() => {
                        sessionStorage.setItem(
                          "homescroll",
                          JSON.stringify({
                            homeScroll:
                              document.querySelector(".content-app").scrollTop,
                          })
                        );
                      }}
                    />
                  </Link>
                </div>
              }
              key={indexImg[4]?.productId}
              skeleton={
                <span
                  className="skeleton-box"
                  style={{
                    width: "43vw",
                    height: "21vh",
                    borderRadius: "15px",
                  }}
                />
              }
              isDiscount={true}
            />
          </>
        ) : (
          "No Discounts"
        )}
      </div>
    </>
  );
};
const SectionHeader = ({ title, icon }) => (
  <div className="container">
    <div
      className="d-flex justify-content-center align-items-center mb-2 mt-3"
      style={{ padding: "0 15px" }}
    >
      <div className="section-header-modern-enhanced d-flex align-items-center gap-3">
        {icon && (
          <div
            className="section-header-icon-enhanced"
            style={{ fontSize: "0.5rem" }}
          >
            {icon}
          </div>
        )}
        <h3 className="mb-0 fw-bold section-header-title-enhanced">{title}</h3>
        {icon && (
          <div
            className="section-header-icon-enhanced"
            style={{ fontSize: "1.5rem" }}
          >
            {icon}
          </div>
        )}
      </div>
    </div>
  </div>
);

const SectionReferral = ({
  title,
  icon,
  handleReferralClick,
  setReferralBanner,
  referralBanner,
}) => (
  <div className="container">
    <div className="d-flex justify-content-center align-items-center mb-3 mt-4">
      <div className="referral-section-card text-center p-4 rounded-4 w-100">
        <div className="d-flex justify-content-center mb-3">
          <div className="referral-icon-wrapper">
            <Trophy size={32} color="#FFC107" />
          </div>
        </div>
        <h5
          className="fw-bold text-warning mb-3"
          style={{ fontSize: "1.1rem", letterSpacing: "0.5px" }}
        >
          Your SpiceGold Reward Awaits!
        </h5>

        <p
          className="mt-2 mb-3 text-light"
          style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
        >
          Came here through a friend? <br />
          Use their referral code & earn SpiceGolds together!
        </p>

        <div className="d-grid gap-2">
          <button
            onClick={handleReferralClick}
            className="referral-primary-btn py-2 text-uppercase fw-bold"
          >
            Yes, Take Me to Referral!
          </button>

          <span
            onClick={() => setReferralBanner(false)}
            className="referral-skip-link text-white-50"
          >
            No, I'll Skip the Bonus for Now
          </span>
        </div>
      </div>
    </div>
  </div>
);

export {
  BannerSlider,
  IndexSlider,
  ProductSlider,
  CategorySlider,
  OtherProductSlider,
  DealofDaySlider,
  Mobile,
  Discounts,
  Discountss,
  filterCategorySlider,
  LazyImage,
  SectionHeader,
  SectionReferral,
};
